import { CLEAR_STORE } from "../../constants/ActionConstants";

export const clearStore = () => ({
    type: CLEAR_STORE,
    data: {}
});